package hk.com.vr360_demo2.webapp.core.ui_state

sealed class UIComponent {

    data class AlertDialog(
        val title: String = "",
        val message: String = "",
        val action: (() -> Unit)? = null
    ) : UIComponent()

    data class TripleButtonDialog(
        val title: String? = null,
        val message: String = "",
        val tertiaryButtonText: String?,
        val onTertiaryButtonClick: () -> Unit,
        val dismissButtonText: String? = null,
        val onDismissButtonClick: (() -> Unit)? = null,
        val confirmButtonText: String? = null,
        val onConfirmation: () -> Unit,
    ) : UIComponent()

    data class ToastSimple(
        val message: String,
        val severity: String = "error",
    ) : UIComponent()

    data class DialogSimple(
        val title: String,
        val description: String
    ) : UIComponent()

    data class None(
        val message: String,
    ) : UIComponent()

}